import Date from '../../../../components/Date/Date'

const OutOfStockOccurrenceDetailsTableRow = ({row, isParentRow}: any) => {
  return (
    <tr>
      {isParentRow && (
        <td>
          <span className='badge badge-lg badge-light-primary'>{row?.childSKU}</span>
        </td>
      )}
      <td>
        <Date date={row?.outOfStockDate} />
      </td>
      <td>
        <Date date={row?.restockDate} />
      </td>
      <td>{row?.restockQuantity}</td>
    </tr>
  )
}
export default OutOfStockOccurrenceDetailsTableRow
